/*
 *   File : App.js
 *   Author : https://evoqins.com
 *   Description :
 *   Integrations : js-cookie,react-toastify
 *   Version : 1.0.0
*/

import React, { useEffect, useState } from 'react';
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Cookies from 'js-cookie';
import { ToastContainer } from 'react-toastify';

//Custom component
import { ConfigurePassword, ForgotPassword, Login } from './Container/Auth';
import { Dashboard as SuperAdminDashboard } from './Container/SuperAdmin/Home';
import { Dashboard as CountryAdminDashboard, ProductDetailPage, SalesBreakdownPage, TopSellingPage } from "./Container/CountryAdmin/Home";
import { CustomHeader, LeftNavigationWidget } from './Component/Navigation';
import { Footer } from './Component/Footer';
import { CountryAdmin, CountryAdminsDetail } from './Container/SuperAdmin/CountryAdmins';
import { StoreListing as SuperAdminStoreListing } from './Container/SuperAdmin/Store';
import { DobChangeHistory, PendingRequest, RequestHistory } from './Container/CountryAdmin/Requests';
import { EmployeeDetail, SalesSpecialist } from './Container/CountryAdmin/Employee';
import { StoreListing, StoreDetail } from './Container/CountryAdmin/Store';
import { CourseDetail, LearningResources, ManageCourse, ManageDownload, ManageFlashQuiz, ManageQuiz, ManageVideo, ResourceOverview } from './Container/CountryAdmin/Learn';
import { ListRewardPoints, RewardDetail, RewardList } from './Container/CountryAdmin/Rewards';
import { OfferListing, RedemptionHistory } from './Container/CountryAdmin/Offers';
import { NotificationList as CountryAdminNotification } from './Container/CountryAdmin/Notification';
import { NotificationList as SuperAdminNotification } from './Container/SuperAdmin/Notifications';
import { ManageNotification } from './Container/CountryAdmin/InAppNotifications';
import { BannerList } from './Container/Banner';
import { CampaignOverview, ListCompetitions, CompetitionDetail } from './Container/CountryAdmin/Competition';
import { ManageNews } from './Container/CountryAdmin/News';
import { ManageProduct } from './Container/CountryAdmin/ManageProduct';
import { Catalog, CatalogDetail, CatalogManageProduct } from './Container/CountryAdmin/Catalog';
import { APIService } from './Service';
import { _isOcrEnabled } from './Helper/country';
import Store from './Store/store';
import { SalesSpikesDetail, SalesSpikesList } from './Container/CountryAdmin/SalesSpikes';
import { Loader } from './Component/Others';
import { InvoiceDetail, OCRSalesAndRewardList } from './Container/CountryAdmin/OCR';

function App() {

    const [toggleSidebar, setToggleSidebar] = useState(true);
    const [token, setToken] = useState(Cookies.get("access_token"));
    const [adminType, setAdminType] = useState(Cookies.get("admin_type") === "1" ? "super_admin" : Cookies.get("admin_type") === "2" ? "country_admin" : null);
    const [browserZoom, setBrowserZoom] = useState(100);

    const [loader, setLoader] = useState(true);
    const [profileData, setProfileData] = useState({});
    const [ocrCountries, setOcrCountries] = useState([]);

    useEffect(() => {
        if (token) {
            _getProfile();
        }
    }, []);

    // useEffect(() => {
    //     setToken(Cookies.get("access_token"));
    // }, [Cookies.get("access_token")]);

    useEffect(() => {
        if (adminType === 'super_admin') {
            document.title = 'Jotun Way Super Admin';
        } else if (adminType === 'country_admin') {
            document.title = 'Jotun Way Country Admin';
        }
    }, [adminType]);

    useEffect(() => {
        // Removing modal backdrop for all modals when use gesture
        window.addEventListener('popstate', function () {
            if (document.querySelector(".modal-backdrop")) {
                document.querySelector(".modal-backdrop").remove();
                document.body.style.overflow = 'unset';
            };

        });
    }, [window.location.pathname]);

    useEffect(() => {
        // Update browser zoom level
        function updateZoom() {
            const newZoom = ((window.outerWidth - 10) / window.innerWidth) * 100;
            const roundedZoom = Math.ceil(newZoom / 5) * 5;
            setBrowserZoom(roundedZoom);
        }
        updateZoom();
        window.addEventListener("resize", updateZoom);
        return () => {
            window.removeEventListener("resize", updateZoom);
        };
    }, []);

    useEffect(() => {
        // Calculate the default zoom level based on the device pixel ratio
        const default_zoom = window.devicePixelRatio;

        const initial_value = `${default_zoom * 100}%`;

        if (initial_value === "150%") {
            document.body.style.zoom = "100%";
        } else {
            document.body.style.zoom = "100%";
        }
    }, []);

    // handle sidebar toggle
    const _handleToggleSidebar = () => {
        setToggleSidebar(!toggleSidebar);
    };


    // API - Get profile api
    const _getProfile = () => {
        let is_post = false;
        let url = adminType === "super_admin" ? 'profile/get' : 'CA/profile/get';
        let data = {};

        APIService(is_post, url, data).then((response) => {
            if (response.status_code === 200) {
                setProfileData(response.data);

                Store.dispatch({
                    type: 'UPDATE_PROFILE_DATA',
                    payload: response.data
                });

                // OCR gating is country-admin only; fetch the enabled-countries list
                if (adminType === "country_admin") {
                    _getOcrEnabledCountries();
                    return;
                }
            }
            setLoader(false);
        });
    };

    // API - Get OCR enabled countries (drives OCR vs redeem UI)
    const _getOcrEnabledCountries = () => {
        APIService(false, 'general/ocr-enabled-countries', {}).then((response) => {
            if (response?.status_code === 200) {
                const ocr_countries = response.ocr_enabled_countries || [];
                setOcrCountries(ocr_countries);

                Store.dispatch({
                    type: 'UPDATE_OCR_COUNTRIES',
                    payload: ocr_countries
                });
            }
            setLoader(false);
        });
    };

    return (
        <div className={` ${browserZoom >= 150 ? 'e-app-zoom-level-7' :
            browserZoom === 125 ? 'e-app-zoom-level-8' :
                browserZoom === 110 ? 'e-app-zoom-level-9' : null
            }`}>
            {token ?
                <Router>
                    <div className='container-fluid min-h-100vh'>
                        {loader ?
                            <Loader />
                            :
                            <div className='row'>
                                <div className={`${toggleSidebar ? `col-2 e-col-2` : `col-1`} px-0 transition d-xl-block d-lg-block d-md-none d-none`}>
                                    <LeftNavigationWidget
                                        toggle={toggleSidebar}
                                        token={adminType}
                                        profileData={profileData}
                                        ocrCountries={ocrCountries} />
                                </div>
                                <div className={`${toggleSidebar ? `col-xl-10 col-lg-10 col-md-12 e-col-10` : `col-xl-11 col-lg-11 col-md-12`} px-0 e-bg-shocking-white transition`}>
                                    <CustomHeader handleToggle={_handleToggleSidebar} token={adminType} />
                                    {adminType === "super_admin" ?
                                        <>
                                            <div className='min-h-100vh'>
                                                <Routes>
                                                    <Route exact path="/" element={<SuperAdminDashboard />} />
                                                    <Route path="country-admin" element={<CountryAdmin />} />
                                                    <Route path="country-admin/detail" element={<CountryAdminsDetail />} />
                                                    {/* <Route path="notification" element={<SuperAdminNotification />} /> */}

                                                    {/* New Features */}
                                                    <Route path='/manage-training'>
                                                        <Route index element={<LearningResources />} />
                                                        <Route path='course-detail' element={<CourseDetail />} />
                                                        <Route path='overview' element={<ResourceOverview />} />
                                                        <Route path='manage-course' element={<ManageCourse />} />
                                                        <Route path='manage-video' element={<ManageVideo />} />
                                                        <Route path='manage-quiz' element={<ManageQuiz />} />
                                                        <Route path='manage-flash-quiz' element={<ManageFlashQuiz />} />
                                                        <Route path='manage-download' element={<ManageDownload />} />
                                                    </Route>
                                                    <Route path='/manage-news' element={<ManageNews />} />
                                                    <Route path='/manage-store' element={<SuperAdminStoreListing />} />

                                                    <Route path="*" element={
                                                        <div className='min-vh-100 d-flex flex-column justify-content-center align-items-center'>
                                                            <p className='mb-0 e-alt-font-noto-sans e-font-52 line-height-62px e-text-raisin-black e-font-weight-700'>
                                                                404
                                                            </p>
                                                        </div>
                                                    } />
                                                </Routes>
                                            </div>
                                            <Footer type={2} token={adminType} />
                                        </>
                                        :
                                        <>
                                            <div className='min-h-100vh'>
                                                <Routes>
                                                    <Route path="/" element={<CountryAdminDashboard />} />
                                                    <Route path="/top-selling" element={<TopSellingPage />} />
                                                    <Route path="/product-detail" element={<ProductDetailPage />} />
                                                    <Route path="/product-detail/sales-breakdown" element={<SalesBreakdownPage />} />


                                                    <Route path="/manage-request">
                                                        <Route index element={<PendingRequest />} />
                                                        <Route path='request-history' element={<RequestHistory />} />
                                                        <Route path='dob-history' element={<DobChangeHistory />} />
                                                    </Route>


                                                    <Route path="/sales-specialist">
                                                        <Route index element={< SalesSpecialist />} />
                                                        <Route path="detail" element={< EmployeeDetail />} />
                                                    </Route>

                                                    <Route path='/store-listing'>
                                                        <Route index element={<StoreListing />} />
                                                        <Route path='detail' element={<StoreDetail />} />
                                                    </Route>

                                                    <Route path='/manage-training'>
                                                        <Route index element={<LearningResources />} />
                                                        <Route path='course-detail' element={<CourseDetail />} />
                                                        <Route path='overview' element={<ResourceOverview />} />
                                                        <Route path='manage-course' element={<ManageCourse />} />
                                                        <Route path='manage-video' element={<ManageVideo />} />
                                                        <Route path='manage-quiz' element={<ManageQuiz />} />
                                                        <Route path='manage-flash-quiz' element={<ManageFlashQuiz />} />
                                                        <Route path='manage-download' element={<ManageDownload />} />
                                                    </Route>

                                                    {_isOcrEnabled(profileData, ocrCountries) ?
                                                        <>
                                                            <Route path='/invoices'>
                                                                <Route index element={<OCRSalesAndRewardList />} />
                                                                <Route path='detail' element={<InvoiceDetail />} />
                                                            </Route>
                                                        </>
                                                        :
                                                        <>
                                                            <Route path='/redeem-offer' element={<OfferListing />} />
                                                            <Route path='/redemption-history' element={<RedemptionHistory />} />
                                                        </>

                                                    }

                                                    <Route path='/rewards'>
                                                        <Route index element={<RewardList />} />
                                                        <Route path='detail' element={<RewardDetail />} />
                                                    </Route>

                                                    <Route path='/manage-product' element={<ManageProduct />}></Route>

                                                    <Route path='/catalog'>
                                                        <Route index element={<Catalog />} />
                                                        <Route path='detail' element={<CatalogDetail />} />
                                                        <Route path='manage-product' element={<CatalogManageProduct />} />
                                                    </Route>

                                                    <Route path='/campaign'>
                                                        <Route index element={<ListCompetitions />} />
                                                        <Route path='overview' element={<CampaignOverview />} />
                                                        <Route path='detail' element={<CompetitionDetail />} />
                                                    </Route>

                                                    {/* <Route path='/reward-points' element={<ListRewardPoints />} /> */}



                                                    <Route path='/notification' element={<CountryAdminNotification />} />
                                                    <Route path='/manage-notification' element={<ManageNotification />} />
                                                    <Route path='/manage-news' element={<ManageNews />} />
                                                    <Route path='/banner-list' element={<BannerList />} />

                                                    <Route path='/manage-fraud'>
                                                        <Route index element={<SalesSpikesList />} />
                                                        <Route path='detail' element={<SalesSpikesDetail />} />
                                                    </Route>


                                                    <Route path="*" element={
                                                        <div className='min-vh-100 d-flex flex-column justify-content-center align-items-center'>
                                                            <p className='mb-0 e-alt-font-noto-sans e-font-52 line-height-62px e-text-raisin-black e-font-weight-700'>
                                                                404
                                                            </p>
                                                        </div>
                                                    } />
                                                </Routes>
                                            </div>
                                            <Footer type={2} token={adminType} />
                                        </>
                                    }
                                </div>
                            </div>
                        }
                    </div>
                </Router>
                :
                <Router>
                    <div className='position-relative min-h-100vh e-bg-indigo'>
                        <Routes>
                            <Route exact path="/" element={<Login />} />
                            <Route exact path="/login" element={<Login />} />
                            <Route path="/forgot-password" element={<ForgotPassword />} />
                            <Route path="/set-password" element={<ConfigurePassword />} />
                            <Route path="*" element={<Login />} />
                        </Routes>
                        {/* footer */}
                        <Footer />
                    </div>
                </Router>
            }

            <ToastContainer
                autoClose={3000}
                pauseOnHover={false}
                position="bottom-right" />
        </div>
    );
}

export default App;
